export default __webpack_public_path__ + "static/media/right.b07ef090.svg";